export default "__VITE_ASSET__3c580f35__"